/**
 * Gets the base URL for the Store Locator.
 * @returns {string} - String representing the base URL for the Store Locator.
 */
const getStoreLocatorBaseURL = () => process.env.STORE_LOCATOR_API_URL || 'https://api.storelocator.hmgroup.tech';
export default getStoreLocatorBaseURL;
//# sourceMappingURL=getStoreLocatorBaseURL.js.map